export class EfectivoConst {
  public static headerTable = [
    { field: 'accountingModelsNumber', title: 'Cuenta', cell: (row) => row.accountingModelsNumber ? `${row.accountingModelsNumber}` : '', class: (row) => `` },
    { field: 'nombre', title: 'Nombre', cell: (row) => row.nombre ? `${row.nombre}` : '', class: (row) => `` },
    { field: 'ubicacion', title: 'Ubicacion', cell: (row) => row.ubicacion ? `${row.ubicacion}` : '', class: (row) => `` },
    { field: 'saldoContable', title: 'Saldo contable', cell: (row) => row.saldoContable ? `${row.saldoContable}` : '0', class: (row) => `` },
    { field: 'fondoDeCaja', title: 'Fondo caja', cell: (row) => row.fondoDeCaja ? `${row.fondoDeCaja}` : '0', class: (row) => `` },
  ];
}
